import Link from 'next/link';

interface Props {
  selected: boolean;
  href: string;
  children: any[];
}

export const AdminLink = ({ selected, href, children }: Props) => {
  return (
    <Link href={href}>
      <a
        className={`border-l-4 border-gray-50 ${
          selected
            ? 'bg-green-50 border-green-dark text-green-dark'
            : 'text-gray-600 hover:bg-green-50 hover:text-gray-900'
        }  group  py-2 px-4 flex items-center text-base font-medium`}>
        {children}
      </a>
    </Link>
  );
};
